<template>
	<SOSlotBase
		:bg-white="true"
		:loading="pageSetting.loading"
	>
		<template v-slot:loading-page>
			<SOLoadingPage/>
		</template>

		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="'Detail Upah Borongan'"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div :style="`padding-bottom: ${isMobileDevice() ? '100px' : '0'}`">
				<div class="p-x-20 p-y-16 border-bottom">
					<div class="f-bold f-18 f-c-black">{{ data.karyawan.nama }}</div>
					<div class="f-regular f-14 f-c-midgrey">
						{{ $moment(data.tanggal_awal).format("DD MMM YYYY") }} -
						{{ $moment(data.tanggal_akhir).utc().format("DD MMM YYYY") }}
					</div>
				</div>
				<div class="p-x-20 p-t-16" v-for="(tahapan, i) in data.upah_tahapan" :key="i" :class="i == data.upah_tahapan.length - 1 ? 'p-d-16' : ''">
					<div class="f-bold f-16 f-c-black d-flex-between-center m-d-2">
						<div>{{ tahapan.nama_tahapan }}</div>
						<div>Rp {{ formatRupiah(tahapan.total_gaji.toString()) }}</div>
					</div>
					<div class="f-regular f-14 f-c-midgrey d-flex-between-center"
						v-for="(kuantitas, j) in tahapan.satuan_kuantitas" :key="j">
						<div>{{ kuantitas.layanan }} • {{ formatRupiah(kuantitas.jumlah_kuantitas.toFixed(2)) }}
							{{ kuantitas.satuan }}
						</div>
						<div>Rp {{ formatRupiah(kuantitas.total.toString()) }}</div>
					</div>
					<div class="p-x-20 m-t-16 separator-line-dot" v-if="data.upah_tahapan.length - 1 !== i"></div>
				</div>
			</div>

			<div class="upah-borongan-diubah p-x-20 p-y-12 btn_action_wrapper" v-if="upahBoronganDiubah">
				<!--			<div class="upah-borongan-diubah p-x-20 p-y-12">-->
				<div class="f-regular f-14 f-c-black">
					Data telah diubah
				</div>
				<div class="f-regular f-12 f-c-midgrey">
					Data upah karyawan ini diubah setelah penggajian. Anda bisa menghitung ulang upah menggunakan data
					yang baru.
				</div>
				<div class="f-semi f-12 f-c-blue" @click="showModal">
					Klik disini untuk menyesuaikan.
				</div>
			</div>
		</template>

		<template v-slot:modal>
			<SOSlotModal
				:modal-id="'modal-penyesuaian-upah-borongan'"
				:modal-title="'Penyesuaian Upah Borongan'"
				@close="closeModal"
			>
				<template v-slot:modal-body>
					<div class="f-regular f-14 f-c-black m-d-16">Berikut data upah yang berubah.</div>
					<div class="card-upah-borongan">
						<div class="d-flex-between-center p-x-12 p-y-12"
						     :class="{'border-bottom': i !== perubahanDataUpahBorongan.length - 1}"
						     v-for="(perubahan, i) in perubahanDataUpahBorongan" :key="i">
							<div class="f-bold f-16 f-c-black">{{ perubahan.tahapan }}</div>
							<div class="d-flex">
								<div class="f-regular f-13 f-c-midgrey">
									Rp {{ formatRupiah(perubahan.gajiAwal.toString()) }}
									<i class="fas fa-arrow-right m-l-4 m-r-4 f-12"></i>
								</div>
								<div class="f-regular f-13 f-c-black">
									Rp {{ formatRupiah(perubahan.gajiTerbaru.toString()) }}
								</div>
							</div>
						</div>
					</div>
				</template>
				<template v-slot:modal-footer>
					<SOButton
						:text="'Sesuaikan Upah Borongan'"
						:loading="pageSetting.btn.save.loading"
						:disable="pageSetting.btn.save.disabled"
						:outline="true"
						:full="true"
						@action="confirmHitungUlang"
					/>
				</template>
			</SOSlotModal>
		</template>
	</SOSlotBase>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

import conn from "@/store/utils/connection";
import routeGroup from "@/store/utils/api-route/base";

export default {
	name: "DetailUpahBorongan",
	components: {
		SOSlotBase,
		SOLoadingPage,
		SOTitleBar,
		SOSlotModal,
		SOButton,
	},
	props: {
		data: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			pageSetting: {
				loading: true,
				btn: {
					save: {
						loading: false,
						disabled: false,
					}
				}
			},
			dataUpahBorongan: {},
			perubahanDataUpahBorongan: [],
			upahBoronganDiubah: false,
		}
	},
	mounted() {
		this.dataHitungUlang()
	},
	methods: {
		back() {
			this.closeModal()
			this.$emit("back")
		},
		showModal() {
			$("#modal-penyesuaian-upah-borongan").modal("show")
		},
		closeModal() {
			$("#modal-penyesuaian-upah-borongan").modal("hide")
		},
		async dataHitungUlang() {
			this.pageSetting.loading = true
			const res = await conn.get(routeGroup.masterData + "upah/data_upah_karyawan_terbaru", {
				idkaryawan: this.data.karyawan.idkaryawan,
				tanggal_awal: this.$moment(this.data.tanggal_awal).format("YYYY-MM-DD") + " 00:00:00",
				tanggal_akhir: this.$moment(this.data.tanggal_akhir).utc().format("YYYY-MM-DD") + " 23:59:59",
			})
			this.pageSetting.loading = false
			window.scrollTo(0, 0);
			if (!res.data.status) {
				this.$toast.error(res.data.msg)
				return
			}
			this.dataUpahBorongan = res.data.data

			// for (let i = 0; i < this.data.upah_tahapan.length; i++) {
			// 	for (let j = 0; j < this.dataUpahBorongan.length; j++) {
			// 		if (this.data.upah_tahapan[i].idtahapan === this.dataUpahBorongan[j].idtahapan) {
			// 			if (this.data.upah_tahapan[i].total_gaji !== this.dataUpahBorongan[j].upah_terbaru) {
			// 				this.perubahanDataUpahBorongan = [
			// 					...this.perubahanDataUpahBorongan,
			// 					{
			// 						tahapan: this.data.upah_tahapan[i].nama_tahapan,
			// 						gajiAwal: this.data.upah_tahapan[i].total_gaji,
			// 						gajiTerbaru: this.dataUpahBorongan[j].upah_terbaru,
			// 					}
			// 				]
			// 			}
			// 		}
			// 	}
			// }
			//
			// for (let i = 0; i < this.data.upah_tahapan.length; i++) {
			// 	for (let j = 0; j < this.dataUpahBorongan.length; j++) {
			// 		if (this.data.upah_tahapan[i].idtahapan === this.dataUpahBorongan[j].idtahapan) {
			// 			if (this.data.upah_tahapan[i].total_gaji !== this.dataUpahBorongan[j].upah_terbaru) {
			// 				this.upahBoronganDiubah = true
			// 				break
			// 			}
			// 		}
			// 	}
			// }

			let tempArr = []
			for (let i = 0; i < this.dataUpahBorongan.length; i++) {
				tempArr = [
					...tempArr,
					{
						idtahapan: this.dataUpahBorongan[i].idtahapan,
						tahapan: this.dataUpahBorongan[i].tahapan,
						gajiAwal: 0,
						gajiTerbaru: this.dataUpahBorongan[i].upah_terbaru,
					}
				]
			}
			for (let i = 0; i < this.data.upah_tahapan.length; i++) {
				let found = false;
				for (let j = 0; j < tempArr.length; j++) {
					if (this.data.upah_tahapan[i].idtahapan === tempArr[j].idtahapan) {
						found = true
						tempArr[j].gajiAwal = this.data.upah_tahapan[i].total_gaji
					}
				}
				if (!found) {
					tempArr = [
						...tempArr,
						{
							idtahapan: this.data.upah_tahapan[i].idtahapan,
							tahapan: this.data.upah_tahapan[i].nama_tahapan,
							gajiAwal: this.data.upah_tahapan[i].total_gaji,
							gajiTerbaru: 0,
						}
					]
				}
			}
			for (let i = 0; i < tempArr.length; i++) {
				if (tempArr[i].gajiAwal !== tempArr[i].gajiTerbaru) {
					this.upahBoronganDiubah = true
					this.perubahanDataUpahBorongan = [
						...this.perubahanDataUpahBorongan,
						{
							idtahapan: tempArr[i].idtahapan,
							tahapan: tempArr[i].tahapan,
							gajiAwal: tempArr[i].gajiAwal,
							gajiTerbaru: tempArr[i].gajiTerbaru,
						}
					]
				}
			}
		},
		async confirmHitungUlang() {
			this.pageSetting.btn.save.disabled = true
			this.pageSetting.btn.save.loading = true
			let form = new FormData
			form.append("idkaryawan", this.data.karyawan.idkaryawan)
			form.append("tanggal_awal", this.$moment(this.data.tanggal_awal).format("YYYY-MM-DD") + " 00:00:00")
			form.append("tanggal_akhir", this.$moment(this.data.tanggal_akhir).format("YYYY-MM-DD") + " 23:59:59")
			const res = await conn.post(routeGroup.masterData + "upah/hitung_ulang_upah_karyawan", form, conn.contentType.form)
			this.pageSetting.btn.save.disabled = false
			this.pageSetting.btn.save.loading = false
			if (!res.data.status) {
				this.$toast.error(res.data.msg)
				return
			}
			this.$toast.success(res.data.msg)
			this.back()
		}
	}
}
</script>

<style scoped>
.upah-borongan-diubah {
	background: #FFF8E1 !important;
	bottom: 72px;
}

.card-upah-borongan {
	border: 1px solid #C8D0DD;
	border-radius: 4px;
	max-height: 300px;
	overflow-y: auto;
}
</style>